module.exports = __webpack_public_path__ + "img/box3.577290bc.png";